import getConfig from 'next/config';

const { NEXT_PUBLIC_APP_ENV } = getConfig().publicRuntimeConfig;

export const IS_DEV = NEXT_PUBLIC_APP_ENV === 'dev';
export const IS_PROD = NEXT_PUBLIC_APP_ENV === 'prod';
export const IS_LOCAL = typeof window !== 'undefined' && window.location.hostname === 'localhost';
